// extracted by mini-css-extract-plugin
export default {"paymentSection":"e8-z"};